﻿import { SaveRequest, SaveResponse, ServiceOptions, DeleteRequest, DeleteResponse, RetrieveRequest, RetrieveResponse, ListRequest, ListResponse, serviceRequest } from "@serenity-is/corelib";
import { EmailQueueRow } from "./EmailQueue.EmailQueueRow";

export namespace EmailQueueService {
    export const baseUrl = 'Serenity.Pro.EmailQueue';

    export declare function Create(request: SaveRequest<EmailQueueRow>, onSuccess?: (response: SaveResponse) => void, opt?: ServiceOptions<any>): PromiseLike<SaveResponse>;
    export declare function Update(request: SaveRequest<EmailQueueRow>, onSuccess?: (response: SaveResponse) => void, opt?: ServiceOptions<any>): PromiseLike<SaveResponse>;
    export declare function Delete(request: DeleteRequest, onSuccess?: (response: DeleteResponse) => void, opt?: ServiceOptions<any>): PromiseLike<DeleteResponse>;
    export declare function Retrieve(request: RetrieveRequest, onSuccess?: (response: RetrieveResponse<EmailQueueRow>) => void, opt?: ServiceOptions<any>): PromiseLike<RetrieveResponse<EmailQueueRow>>;
    export declare function List(request: ListRequest, onSuccess?: (response: ListResponse<EmailQueueRow>) => void, opt?: ServiceOptions<any>): PromiseLike<ListResponse<EmailQueueRow>>;

    export const Methods = {
        Create: "Serenity.Pro.EmailQueue/Create",
        Update: "Serenity.Pro.EmailQueue/Update",
        Delete: "Serenity.Pro.EmailQueue/Delete",
        Retrieve: "Serenity.Pro.EmailQueue/Retrieve",
        List: "Serenity.Pro.EmailQueue/List"
    } as const;

    [
        'Create', 
        'Update', 
        'Delete', 
        'Retrieve', 
        'List'
    ].forEach(x => {
        (<any>EmailQueueService)[x] = function (r, s, o) {
            return serviceRequest(baseUrl + '/' + x, r, s, o);
        };
    });
}